import React, { useState, useEffect, memo } from 'react';
import { logDebug } from 'utils/logger';
import { useSearchParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel } from 'swiper/modules';
import { useTeamColors } from 'hooks';
import { PrevArrowIcon, NextArrowIcon } from 'assets/icons';

import GameDate from 'components/GameDate';
import {
  GameInfoButton,
  Teams,
  TvChannel,
  LeagueName,
  GameResult,
} from 'components';
import { CurrentGameButton } from './components/CurrentGameButton';

import 'swiper/swiper-bundle.css';
import {
  StyledSection,
  LeftSideBar,
  RightSideBar,
  SlideContent,
  ArrowWrapper,
} from './style';

const DashboardOneTeam = ({
  games,
  currentGame,
  configuration,
  setEventLeague,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const { mainColor } = useTeamColors();
  const [progress, setProgress] = useState(games?.[currentGame]?.event_id);

  // Sync progress with currentGame when games data loads
  useEffect(() => {
    if (games?.[currentGame]?.event_id && !progress) {
      setProgress(games[currentGame].event_id);
    }
  }, [games, currentGame, progress]);

  //** URL CHANGE ** //
  useEffect(() => {
    if (progress && configuration.one_team_name && configuration.one_team_id) {
      setSearchParams(
        (prevValue) => {
          prevValue.set('team', configuration.one_team_name);
          prevValue.set('teamId', configuration.one_team_id);
          prevValue.set('eventId', progress);
          return prevValue;
        },
        { replace: true }
      );
    }
    // eslint-disable-next-line
  }, [progress]);

  //** FIND event_id FUNCTION */
  const slideChanged = (index) => {
    if (!games) return;
    const oneGame = games[index]?.event_id;
    if (oneGame) {
      setProgress(oneGame);
    }
    const eventLeagueName = games[index]?.event_league_name;
    if (eventLeagueName) {
      console.dir(eventLeagueName);
      setEventLeague(eventLeagueName);
    }
  };

  const [localEventLeague, setLocalEventLeague] = useState('');

  useEffect(() => {
    if (games?.length && localEventLeague == '') {
      let event = games[0];
      if (event?.event_league_name) {
        setLocalEventLeague(event.event_league_name);
        setEventLeague(event.event_league_name);
      }
    }
  }, [games, setEventLeague, localEventLeague]);

  return (
    <>
      <LeftSideBar>
        <ArrowWrapper className="swiper-button-prev-unique">
          <PrevArrowIcon fill={mainColor} />
        </ArrowWrapper>
      </LeftSideBar>
      <StyledSection>
        <Swiper
          grabCursor={true}
          id="main-slider"
          initialSlide={currentGame}
          modules={[Navigation, Mousewheel]}
          mousewheel={true}
          navigation={{
            prevEl: '.swiper-button-prev-unique',
            nextEl: '.swiper-button-next-unique',
          }}
          onSlideChange={(swiper) => {
            slideChanged(swiper.activeIndex);
          }}
          slidesPerView={1}
          tag="section"
          wrapperTag="ul"
        >
          {games?.map((game, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SwiperSlide key={`${game.event_id}-${index}`} tag="li">
              <SlideContent>
                <Teams
                  eventType={game?.event_type}
                  location={game.event_location}
                  opponent={game.event_text}
                  team={configuration.one_team_name}
                />
                {game?.event_league_name && game?.event_league_name != '' ? (
                  <LeagueName leagueName={game?.event_league_name} />
                ) : null}
                {(() => {
                  return game.stadium_address && game.stadium_name ? (
                    <GameInfoButton
                      city={game.location_city}
                      date={game.event_start}
                      eventLeagueName={
                        game.event_league_name || localEventLeague
                      }
                      eventType={game?.event_type}
                      locationId={game.event_location_id}
                      opponent={game.event_text}
                      region={game.stadium_country}
                      stadium={game.stadium_name}
                      stadiumLocation={{
                        lat: game?.stadium_lat,
                        lng: game?.stadium_lng,
                      }}
                      team={configuration.one_team_name}
                      timeZone={game.stadium_time_zone}
                      zipCode={game.stadium_zip_code}
                      channel={game.event_tv_channel}
                      eventState={game.event_state}
                      headline={game.event_notes_headline}
                    />
                  ) : null;
                })()}
                <GameDate
                  eventState={game.event_state}
                  eventTime={game.event_start}
                />
                <TvChannel channel={game.event_tv_channel} />
                <GameResult
                  date={game.event_start}
                  eventNotesHeadline={game.event_notes_headline}
                  eventState={game.event_state}
                  result={game.event_outcome}
                />
                <CurrentGameButton />
              </SlideContent>
            </SwiperSlide>
          ))}
        </Swiper>
      </StyledSection>
      <RightSideBar>
        <ArrowWrapper className="swiper-button-next-unique">
          <NextArrowIcon fill={mainColor} />
        </ArrowWrapper>
      </RightSideBar>
    </>
  );
};

export default memo(DashboardOneTeam);
